module.exports = __webpack_public_path__ + "img/header-logo.b09d3bbd.png";